import {
  TimerIcon,
  CheckMarkIcon,
  ManagerIcon,
  MirrorIcon,
  XIcon,
} from "../components/icons";
export const SIGNUP_THRESHOLD = 100; // Each level spans 100 signups
export const BASE_RATE = 1.0; // Starting rate: $1.00
export const BONUS_PER_LEVEL = 0.25; // Each level adds $0.25
export const MAX_RATE = 2.0; // The rate is capped at $2.00

export const BrandAmbassadorRewardlevels = [
  {
    name: "Member",
    pointsRange: [0, 100],
    rate: 1.0,
    icon: "/starlevel.svg",
  },
  {
    name: "Silver",
    pointsRange: [101, 200],
    rate: 1.25,
    icon: "/silverlevel.svg",
  },
  {
    name: "Gold",
    pointsRange: [201, 300],
    rate: 1.5,
    icon: "/goldlevel.svg",
  },
  {
    name: "Platinum",
    pointsRange: [301, 400],
    rate: 1.75,
    icon: "/platinumlevel.svg",
  },
  {
    name: "Black Diamond",
    pointsRange: [401, Infinity],
    rate: 2.0,
    icon: "/diamondlevel.svg",
  },
];

export const METRIC_IDS = {
  BE_ON_TIME: 1,
  MEET_DAILY_GOALS: 2,
  BE_RESPECTFUL: 3,
  NEAT_CLEAN_ATTIRE: 4,
  RESPONSIBLE_CANCELATION: 5,
};

export const metricStandingMessages = {
  [METRIC_IDS.BE_ON_TIME]: {
    name: "Be on time",
    icon: <TimerIcon className="metric-icon" />,
    issues: {
      0: "Excellent! Always on time.",
      1: "Minor delay—try to plan ahead.",
      2: "Frequently late—improve your punctuality.",
    },
  },
  [METRIC_IDS.MEET_DAILY_GOALS]: {
    name: "Meet Daily Goals",
    icon: (
      <CheckMarkIcon
        height="25"
        width="25"
        fillColor="var(--color-yellowgold)"
        className="metric-icon"
      />
    ),
    dailyGoalIssueCount: {
      0: "Goals met!",
      1: "Slightly off—adjust your approach.",
      2: "Significantly below target—review strategy.",
    },
  },
  [METRIC_IDS.BE_RESPECTFUL]: {
    name: "Be Repsectful",
    icon: <ManagerIcon className="metric-icon" />,
    respectfulIssueCount: {
      0: "Always respectful.",
      1: "Occasional lapses—stay courteous.",
      2: "Needs improvement—be more respectful.",
    },
  },
  [METRIC_IDS.NEAT_CLEAN_ATTIRE]: {
    name: "Neat & Clean Appearance",
    icon: <MirrorIcon className="metric-icon" />,
    cleanAppearanceIssueCount: {
      0: "Impeccable appearance.",
      1: "Minor lapses in neatness.",
      2: "Needs improvement in presentation.",
    },
  },
  [METRIC_IDS.RESPONSIBLE_CANCELATION]: {
    name: "Resposbile Cancelation",
    icon: (
      <XIcon
        height="20"
        width="35"
        fillColor="var(--color-yellowgold)"
        className="metric-icon"
      />
    ),
    cancelationIssueCount: {
      0: "No issues reported.",
      1: "Occasional cancellations—be more proactive.",
      2: "High cancellation rate—review responsibilities.",
    },
  },
};


export function standingLabelFormatter(value) {
  const v = Math.round(value);
  switch (v) {
    case 3:
      return "Fantastic";
    case 2:
      return "Great";
    case 1:
      return "Fair";
    case 0:
      return "At Risk";
    default:
      return "";
  }
}
